import React, { useState } from "react";
import { getUser } from "../../Localstorage/localstorage";
import FilterNavigation from "../../Componenten/Dashboard/FilterNavigation";
import { TableCellsIcon } from "@heroicons/react/20/solid";
import { Squares2X2Icon } from "@heroicons/react/24/outline";
import DashboardlistPatient from "../../Componenten/Dashboard/DashboardlistPatient";
import DashboardPatientCards from "../../Componenten/Dashboard/DashboardPatientCards";
import DashboardPatientCards2 from "../../Componenten/Dashboard/DashboardPatientCards2";
import { useNavigate } from "react-router-dom";
import SelectDetailsPatient from "../../Componenten/SelectDetailsPatient";

const filters = [
  { value: 1, name: "list", icon: TableCellsIcon, color: "text-green-500" },
  { value: 2, name: "block", icon: Squares2X2Icon, color: "text-green-500" },
];

const DashboardAdmin = () => {
  const [patienten, setPatienten] = useState(null);
  const [selectFilter, setselectFilter] = useState(2);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const user = getUser();
  const navigate = useNavigate();

  const goToDetails = (item) => {
    navigate("/dashboarddetail", { state: { user: item } });
  };

  const setSelectedRadio = (option) => {
    if (option?.value != null) setselectFilter(option.value);
  };

  const showInitialLoading = loading && patienten === null;
  const patientCount = patienten?.length || 0;

  return (
    <div className="min-h-0 flex-1 bg-wa-app px-3 pb-8 pt-4 text-wa-text sm:px-4 lg:px-6">
      {user ? (
        <>
          <header className="mb-6 rounded-2xl border border-wa-border bg-wa-panel p-4 sm:p-5">
            <div className="mb-3 flex flex-col items-start justify-between gap-3 sm:flex-row sm:items-center">
              <div>
                <h1 className="text-lg font-semibold tracking-tight text-wa-text sm:text-xl">
                  Patiëntenoverzicht
                </h1>
                <p className="text-sm text-wa-text/70">
                  Beheer en contacteer je actieve patiënten.
                </p>
              </div>
              <span className="inline-flex items-center rounded-full border border-wa-border bg-wa-panel2 px-3 py-1 text-xs font-semibold text-wa-text/70">
                {patientCount} gevonden
              </span>
            </div>

            <div className="flex flex-col gap-3 lg:flex-row lg:items-center lg:justify-between lg:gap-4">
              <FilterNavigation
                setSelectedRadio={setSelectedRadio}
                selectedRadio={selectFilter}
                options={filters}
              />
              <div className="min-w-0 flex-1 lg:max-w-3xl lg:justify-self-end xl:max-w-4xl">
                <SelectDetailsPatient
                  setData={setPatienten}
                  setLoading={setLoading}
                  setError={setError}
                />
              </div>
            </div>
          </header>

          {showInitialLoading ? (
            <p className="py-8 text-center text-sm text-wa-muted">Laden…</p>
          ) : null}
          {error ? (
            <p className="mb-4 rounded-lg border border-red-800/40 bg-red-950/30 px-3 py-2 text-sm text-red-200">
              {error}
            </p>
          ) : null}

          <div className="min-w-0">
            {selectFilter === 2 ? (
              <DashboardPatientCards goToDetails={goToDetails} patienten={patienten} />
            ) : selectFilter === 1 ? (
              <DashboardlistPatient goToDetails={goToDetails} patienten={patienten || []} />
            ) : (
              <DashboardPatientCards2 goToDetails={goToDetails} patienten={patienten || []} />
            )}
          </div>
        </>
      ) : (
        <p className="py-8 text-center text-sm text-wa-muted">Geen gebruikerssessie.</p>
      )}
    </div>
  );
};

export default DashboardAdmin;
